// DS: DS6.1.8 - List Item Radio Card
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import omit from 'lodash/omit';
import RadioButton from '@wix/da-a11y/pkg/components/formControls/RadioButton';
import RadioButtonDS from '../../../../RadioButton/';
import { useListItemCard } from '../../common';
import ListItemContent from '../../../ListItem/legos/ListItemContent';
import s from './ListItemCardRadioButton.scss';
const ListItemCardRadioButton = (_param)=>{
    var { withControl, labelClassName } = _param, unfilteredProps = _object_without_properties(_param, [
        "withControl",
        "labelClassName"
    ]);
    const _useListItemCard = useListItemCard(unfilteredProps), { rootProps: { name, value, onChange, checked, className }, contentProps, ref } = _useListItemCard, restRootProps = _object_without_properties(_useListItemCard.rootProps, [
        "name",
        "value",
        "onChange",
        "checked",
        "className"
    ]);
    return withControl ? /*#__PURE__*/ React.createElement(RadioButtonDS, {
        className: c(s['root'], className),
        inputClassName: s['input'],
        name: name || '',
        value: value || '',
        onChange: onChange && (()=>onChange(!checked, value)),
        checked: !!checked
    }, /*#__PURE__*/ React.createElement(ListItemContent, contentProps)) : /*#__PURE__*/ React.createElement(RadioButton, _object_spread({
        ref: ref,
        name: name || '',
        value: value || '',
        className: labelClassName,
        onChange: onChange && (()=>onChange(!checked, value)),
        checked: !!checked,
        // We need to be a bit wacky with aria prop passing and typing here to preserve the underlying RadioButton's
        // accessibility guardrails.
        hasAccessibleText: unfilteredProps.hasAccessibleText,
        "aria-labelledby": unfilteredProps['aria-labelledby'],
        "aria-label": unfilteredProps['aria-label']
    }, omit(restRootProps, [
        'aria-label',
        'aria-labelledby',
        'hasAccessibleText'
    ])), /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(ListItemContent, contentProps)));
};
ListItemCardRadioButton.displayName = 'ListItemCardRadioButton';
export default ListItemCardRadioButton;

//# sourceMappingURL=ListItemCardRadioButton.js.map